import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_servicios } from "../../config/apiConfig";
import "../../pages/user/css/Empleo.css";

const ServiciosAyuntamiento = () => {
  const [servicios, setServicios] = useState([]);

  useEffect(() => {
    const fetchServicios = async () => {
      try {
        const res = await fetch(API_servicios);
        const data = await res.json();
        setServicios(data);
      } catch (error) {
        console.error("Error al cargar servicios del ayuntamiento:", error);
      }
    };

    fetchServicios();
  }, []);

  return (
    <div className="align-center w-100 noticias-container noticias">
      {servicios.map((servicio) => (
        <div
          key={servicio._id || servicio.nombre}
          className="noticia column social servicio-ayuntamiento gap-5"
        >
          <h2 className="mayusculas">{servicio.nombre}</h2>
          <Link
            className="azul"
            to={`/servicio-ayuntamiento/${encodeURIComponent(servicio.nombre)}`}
            aria-label="Más información sobre el servicio"
          >
            Más información
          </Link>
        </div>
      ))}
      {servicios.length === 0 && (
        <p className="align-center w-100">No hay servicios disponibles</p>
      )}
    </div>
  );
};

export default ServiciosAyuntamiento;
